import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useContentLanguages } from "@common/composable/useMetaDataStore";
import { ERPSection } from "@medapro-types/ContentEditor/Components/ExcelEditEditor";
import { ErpAttributeModel } from "@medapro-types/common/common";
import { Branch, Leaf, MultiLevelNavigationConfirmModel } from "@medapro-types/common/components/MultiLevelNavigation";
import erpAttributesApi from "@services/erpAttributes.js";
import erpSectionsApi from "@services/erpSections.js";
import { computed } from "vue";
import MultiLevelNavigationModal from "./MultiLevelNavigationModal.vue";

const BRANCH_ICON = "Section";
const LEAF_ICON = "Attribute";

//#region General

export default /*#__PURE__*/_defineComponent({
  __name: 'ERPAttributeSelectionModal',
  props: {
    value: { type: Boolean },
    selectedEntryId: {},
    selectedPath: {}
  },
  emits: ["confirm", "cancel", "close", "input", "hide"],
  setup(__props: any, { emit: emits }) {

const props = __props;




//#endregion

//#region Store
const { primaryLanguageCode } = useContentLanguages();
//#endregion

const onConfirm = (event: MultiLevelNavigationConfirmModel) => {
  emits("confirm", event);
};

//#region localValue
const localValue = computed({
  get: () => props.value,
  set: (nv) => emits("input", nv)
});

//#endregion

//#region FetchMethods
const getERPSection = async (groupId: string | null | undefined): Promise<Branch[]> => {
  if (groupId || groupId === "") return [];
  const fetchResult: Record<string, ERPSection>[] = await erpSectionsApi.get([primaryLanguageCode.value]);

  return fetchResult.map((x) => ({
    id: x[primaryLanguageCode.value].erpSectionId,
    depth: 0,
    name: x[primaryLanguageCode.value].name,
    parentId: "",
    icon: BRANCH_ICON
  }));
};

const getErpAttribute = async (sectionId: string | null | undefined): Promise<Leaf[]> => {
  if (!sectionId) return [];
  const fetchResult: Record<string, ErpAttributeModel>[] = await erpAttributesApi.get([primaryLanguageCode.value], sectionId);
  return fetchResult.map((x) => ({
    id: x[primaryLanguageCode.value].erpAttributeId,
    name: x[primaryLanguageCode.value].name,
    dataType: x[primaryLanguageCode.value].dataType,
    icon: LEAF_ICON
  }));
};
//#endregion

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MultiLevelNavigationModal, {
    modelValue: localValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localValue).value = $event)),
    "modal-title": _ctx.$t('selectErpAttribute'),
    "fetch-branches": getERPSection,
    "fetch-leaves": getErpAttribute,
    "selectable-type": ['leaf'],
    "selected-entry-id": _ctx.selectedEntryId,
    "selected-path": _ctx.selectedPath,
    "base-path-title": _ctx.$t('erpAttributes'),
    "with-all": "",
    onConfirm: onConfirm,
    onHide: _cache[1] || (_cache[1] = ($event: any) => (emits('hide'))),
    onCancel: _cache[2] || (_cache[2] = ($event: any) => (emits('cancel'))),
    onClose: _cache[3] || (_cache[3] = ($event: any) => (emits('close')))
  }, null, 8, ["modelValue", "modal-title", "selected-entry-id", "selected-path", "base-path-title"]))
}
}

})